import '../../node_modules/bootstrap/js/src/modal'

import './bootstrap/blockui'
import './bootstrap/scrolltrigger'

import './menu-horizontal'
import './modal-newsletter'
import './hero-section'
import './push-section'
import './push-account'
import './products'
// import './sliders-section'
import './splash-screen'

import './pages/cart'
import './pages/single-product'